import { animate, inView, cubicBezier } from "motion";

const initBulletListHoverVisuals = () => {
    const sections = document.querySelectorAll(".bullet-list");

    sections.forEach((section) => {
        const items = section.querySelectorAll(".bullet-list__item");
        if (!items.length) return;

        const visualsContainer = section.querySelector(".bullet-list__visuals");
        if (!visualsContainer) return;

        const visuals = visualsContainer.querySelectorAll(".bullet-list__visual");
        if (!visuals.length) return;

        let currentIndex = Array.from(visuals).findIndex((v) => v.classList.contains("is-active"));
        if (currentIndex < 0) currentIndex = 0;

        const setActive = (nextIndex) => {
            if (nextIndex === currentIndex || nextIndex < 0 || nextIndex >= visuals.length) return;

            const prevVisual = visuals[currentIndex];
            const nextVisual = visuals[nextIndex];

            items[currentIndex]?.classList.remove("is-active");
            items[nextIndex]?.classList.add("is-active");

            prevVisual.classList.remove("is-active");
            nextVisual.classList.add("is-active");

            animate(prevVisual, { opacity: 0 }, { duration: 0.3, ease: "easeInOut" });
            animate(nextVisual, { opacity: 1 }, { duration: 0.3, ease: "easeInOut" });

            currentIndex = nextIndex;
        };

        items.forEach((item, idx) => {
            item.addEventListener("mouseenter", () => setActive(idx));
            item.addEventListener("focus", () => setActive(idx));
            item.addEventListener("keydown", (e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setActive(idx);
                }
            });
        });
    });
};

const initBulletListItemInView = () => {
    const sections = document.querySelectorAll(".bullet-list");

    sections.forEach((section) => {
        const items = section.querySelectorAll(".bullet-list__item");
        if (!items.length) return;

        // Set initial hidden/offset state per index (closer to 0 for low index, to -200 for high index)
        const getStartX = (idx) => {
            if (items.length <= 1) return -150;
            const min = -40;
            const max = -250;
            const t = idx / (items.length - 1);
            return Math.round(min + (max - min) * t);
        };

        items.forEach((item, index) => {
            animate(item, { opacity: 0, x: getStartX(index) }, { duration: 0 });
        });

        // Animate items in when the section enters the viewport
        inView(
            section,
            () => {
                const smoothOut = cubicBezier(0.22, 1, 0.36, 1);

                items.forEach((item, index) => {
                    const startX = getStartX(index);
                    animate(
                        item,
                        { opacity: [0, 1, 1, 1], x: [startX, 4, -2, 0] },
                        {
                            duration: 4,
                            easing: [smoothOut, smoothOut, smoothOut],
                            // delay: index * 0.02,
                            delay: 0,
                        }
                    );
                });
            },
            { once: true, margin: "0px 0px -200px 0px" }
        );
    });
};

const initBulletList = () => {
    initBulletListHoverVisuals();
    initBulletListItemInView();
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBulletList);
} else {
    initBulletList();
}
